<template>
  <el-dialog id="loginAbnornal" :title="title" :visible.sync="dialogVisible" :close-on-click-modal='false' :before-close="hideDialog" :custom-class="type=='2'?'redDialog':'mainDialog'">
    <template v-if="type=='1'">
      <p>当前页面长时间未操作或已使用其他账号登录</p>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="reLoad">请重新加载</el-button>
      </span>
    </template>
    <template v-else>
      <p>抱歉！当前账号已在别处登录，您将被强制登出。</p>
      <p>如非本人操作，请及时修改登录密码确保账户安全。</p>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary"  @click="go">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
  import { mapActions } from "vuex";
  import userService from '../../common/user';
  export default {
    props:['type'],
    data() {
      return {
        dialogVisible: true,
        title: "重新加载",
      };
    },
    methods: {
      ...mapActions(["fetchAccount"]),
      hideDialog() {
        this.dialogVisible = false;
        this.go();
      },
      go(){
        userService.logout();
      },
      reLoad(){
        userService.logout();
      }
    },
    mounted(){
      this.title = this.type == "1"?"重新加载":"异常登录提醒";
    }
  };
</script>
<style lang="scss" scoped>
  .cont{
    width: 52%;
    height: 80px;
    border: 1px solid var(--contact-division-color);
    background: #fff;
    float: left;
    margin-bottom: 20px;
    position: relative;
    border-radius: 4px;
    img{
      position: absolute;
      left: 15px;
      top:28px;
    }
    p{
      display: inline-block;
      margin-left: 49px;
      line-height: 24px;
      margin-top: 12px;
    }
  }
  .left{
    width: 46%;
    img{
      left: 25px;
    }
    p{
      margin-left: 69px;
    }
  }
  .checkBox{
    clear: both;
    width: 80%;
    height: 60px;
    margin: 30px auto 20px;
    position: relative;
    .checkTitle{
      position: absolute;
      left: 30px;
      height: 100%;
      font-weight: 600;
      font-size:16px;
      color:#333;
    }
    .checkCont{
      margin-left: 200px;
      p.active{
        color:var(--theme-color);
      }
    }
  }
  p {
    text-align: left;
    span {
      padding: 5px 10px;
      border-radius: 4px;
      border: 1px solid var(--contact-division-color);
      display: inline-block;
      margin-top: 8px;
      cursor: pointer;
      &.active {
        border-color: var(--theme-color);
        color: var(--theme-color);
      }
    }
  }
</style>
<style lang="scss">
  p {
    &.margin-top {
      label {
        margin-top: 8px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/account/loginAbnormal.vue